import { render, staticRenderFns } from "./knowledgeDocDetail.vue?vue&type=template&id=1114dbf6&scoped=true"
import script from "./knowledgeDocDetail.vue?vue&type=script&lang=js"
export * from "./knowledgeDocDetail.vue?vue&type=script&lang=js"
import style0 from "./knowledgeDocDetail.vue?vue&type=style&index=0&id=1114dbf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1114dbf6",
  null
  
)

export default component.exports